import type { OverridableComponent } from '@material-ui/core/OverridableComponent'
import type {
  TableRowProps as MuiTableRowProps,
  TableRowTypeMap as MuiTableRowTypeMap
} from '@material-ui/core/TableRow'
import MuiTableRow from '@material-ui/core/TableRow'
import type { Theme } from '@material-ui/core'
import { makeStyles } from '@material-ui/core'
import React, { useContext } from 'react'
import type { StyleClasses } from '../../styles'
import { TableHeadContext } from './TableHead'

export interface TableRowProps extends MuiTableRowProps {
  classes?: StyleClasses<typeof useStyles>
  noBorder?: boolean
  borderWidth?: number
}

interface TableRowTypeMap<P = unknown, D extends React.ElementType = 'tr'> extends MuiTableRowTypeMap<P, D> {
  props: MuiTableRowTypeMap<P, D>['props'] & {
    noBorder?: boolean
    borderWidth?: number
  }
}

const useStyles = makeStyles<Theme, TableRowProps & { isHead: boolean }>(
  (theme: Theme) => ({
    root: {
      boxSizing: 'border-box',
      cursor: ({ onClick, isHead }) => (onClick && !isHead ? 'pointer' : 'inherit'),
      background: ({ isHead }) => (isHead ? 'inherit' : 'transparent'),
      borderBottom: ({ noBorder, borderWidth }) =>
        noBorder ? 'none' : `${borderWidth ?? 1}px solid ${theme.palette.divider}`
    }
  }),
  { name: 'TableRow' }
)

const TableRow: OverridableComponent<TableRowTypeMap> = ({ children, noBorder, ...props }: TableRowProps) => {
  const { isHead } = useContext(TableHeadContext)
  const classes = useStyles({ ...props, isHead, noBorder })

  return (
    <MuiTableRow component="div" {...props} classes={classes}>
      {children}
    </MuiTableRow>
  )
}

export default TableRow
